import React, { Component } from "react";
import PropTypes from "prop-types";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";
import { formatNumber, shouldHideField } from "../../../utils/numberFormatting";

import { isDefined, functor } from "../utils";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";

// Canvas-based text measurement utility
let measureCanvas;
function getTextWidth(text, fontFamily = "Arial", fontSize = 12) {
  if (!measureCanvas) {
    measureCanvas = document.createElement("canvas");
  }
  const context = measureCanvas.getContext("2d");
  context.font = `${fontSize}px ${fontFamily}`;
  const metrics = context.measureText(text);
  return metrics.width;
}

// Constants
const TOOLTIP_BG_HEIGHT = 18;
const TOOLTIP_BG_PADDING = 6;

class DarvasBoxTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      onClick,
      fontFamily,
      fontSize,
      yAccessor,
      displayFormat,
      className,
    } = this.props;
    const { options, labelFill, textFill, bgFill } = this.props;
    const { displayValuesFor } = this.props;
    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const darvasBox = isDefined(currentItem) && currentItem.darvasBox;
    const ghostBox = isDefined(currentItem) && currentItem.ghostBox;

    // Show tooltip only if there's an active box
    if (!darvasBox && !ghostBox) {
      return null;
    }

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const athLookbackPeriod = options.athLookbackPeriod || 100;
    const tooltipLabel = `Darvas Box (${athLookbackPeriod}): `;

    let displayText = "";
    if (darvasBox) {
      const high = displayFormat(darvasBox.High);
      const low = displayFormat(darvasBox.Low);
      displayText = `${high} - ${low}`;
    } else if (ghostBox) {
      const high = displayFormat(ghostBox.High);
      const low = displayFormat(ghostBox.Low);
      displayText = `Ghost: ${high} - ${low}`;
    }

    // Hide if value is n/a
    if (shouldHideField(displayText)) {
      return null;
    }

    const fullText = tooltipLabel + displayText;

    // Calculate text width for background
    const textWidth = getTextWidth(
      fullText,
      fontFamily || "Arial",
      fontSize || 12,
    );
    const bgWidth = textWidth + TOOLTIP_BG_PADDING * 2;

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-darvas-box"
      >
        {/* Background rectangle */}
        <rect
          x={-TOOLTIP_BG_PADDING}
          y={-5}
          width={bgWidth}
          height={TOOLTIP_BG_HEIGHT}
          fill={bgFill || "#1f2937"}
          rx={6}
          ry={6}
        />
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>{tooltipLabel}</ToolTipTSpanLabel>
          <tspan fill={textFill}>{displayText}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

DarvasBoxTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  options: PropTypes.shape({
    athLookbackPeriod: PropTypes.number.isRequired,
  }).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  yAccessor: PropTypes.func,
  displayFormat: PropTypes.func,
  displayValuesFor: PropTypes.func,
  onClick: PropTypes.func,
  labelFill: PropTypes.string,
  textFill: PropTypes.string,
  bgFill: PropTypes.string,
};

DarvasBoxTooltip.defaultProps = {
  origin: [0, 10],
  className: "react-stockcharts-tooltip-hover",
  displayFormat: (d) => formatNumber(d, 2),
  displayValuesFor: displayValuesFor,
  yAccessor: (d) => d,
  labelFill: "#4682B4",
  textFill: "#FFFFFF",
};

export default DarvasBoxTooltip;
